import ApiHandler from "./ApiHandler";

const PreParticipant = {
  findAll: async (query) => await ApiHandler.i.auth().get(`/pre-participant?${query.toString()}`),
  findOne: async (query) => await ApiHandler.i.auth().get(`/pre-participant/find?${query.toString()}`),
  getCount: async (query) => await ApiHandler.i.auth().get(`/pre-participant/count?${query.toString()}`),
  getEducationCertificatesArchive: async () => await ApiHandler.i.auth().get(`/pre-participant/education-certificates-archive`),
  getHistory: async (query) => await ApiHandler.i.auth().get(`/pre-participant/history?${query.toString()}`),
  getMyHistory: async (query) => await ApiHandler.i.auth().get(`/pre-participant/my-history?${query.toString()}`),
  getOne: async (preParticipantId) => await ApiHandler.i.auth().get(`/pre-participant/${preParticipantId}`),
  getPassportsArchive: async () => await ApiHandler.i.auth().get(`/pre-participant/passports-archive`),
  postEducationCertificatesArchive: async () => await ApiHandler.i.auth().post(`/pre-participant/education-certificates-archive-create`, {}),
  postPassportsArchive: async () => await ApiHandler.i.auth().post(`/pre-participant/passports-archive-create`, {}),
};

export default PreParticipant;